import { STANDARD_COVER_LETTER } from '@components/userDocuments/editDocument/editResume/EditSpace/EditorPane/Pad/ExpertTips/Shared/expertTipsEnums';
import { DocumentNames } from '../../constants/templateDictionaries';
import templateDefaultProps from '../../constants/templateDefaultProps';

import getInput from './getInput';
import getSkills from './getSkills';
import getEditableDiv from './getEditableDiv';
import getCustomTemplateColorPalette from '../../utility/universityPolicies/getCustomTemplateColorPalette';

let isSmallScreen;
if (typeof window !== `undefined`) {
  isSmallScreen = window.innerWidth < 1280;
}

export default ({ universityPlan = null }) => ({
  templateType: DocumentNames.COVER_LETTER,
  permissions: null,
  documentName: 'Untitled Cover Letter',
  status: 0,
  coverLetterType: 'Attractive',
  editedInputs: [],
  userPreferences: {
    fieldOfStudy: STANDARD_COVER_LETTER,
    layout: {
      previewPad: !isSmallScreen,
      galleryPad: false,
      leftPane: false,
      menuBar: true,
      galleryPadFullScreen: true,
      tetraScan: false,
      tipsPad: false,
    },
    colorPalette: getCustomTemplateColorPalette({
      universityPlan,
    }),
    templateProperty: {
      default: { ...templateDefaultProps.COVER_LETTER },
      updated: {},
    },
    showIcons: {
      personalLinks: false,
    },
    showTexts: {
      personalLinks: false,
    },
    showLinks: {
      personalLinks: true,
    },
    covid19vaccinated: 'not',
  },

  senderName: getInput({ preTag: 'sender_name', componentKey: 'senderName' }),
  senderTagline: getInput({
    preTag: 'sender_tagline',
    componentKey: 'senderTagline',
  }),
  senderPhoneNumber: getInput({
    preTag: 'sender_phone_number',
    componentKey: 'senderPhoneNumber',
  }),
  senderAddress: getInput({
    preTag: 'sender_address',
    componentKey: 'senderAddress',
  }),
  senderEmail: getInput({
    preTag: 'sender_email',
    componentKey: 'senderEmail',
  }),
  personalLinks: getSkills({
    preTag: 'personal_link',
    componentKey: 'personalLinks',
  }),
  receiverName: getInput({
    preTag: 'receiver_name',
    componentKey: 'receiverName',
  }),
  receiverTagline: getInput({
    preTag: 'receiver_tagline',
    componentKey: 'receiverTagline',
  }),
  receiverOrganization: getInput({
    preTag: 'receiver_organization',
    componentKey: 'receiverOrganization',
  }),
  receiverAddress: getInput({
    preTag: 'receiver_address',
    componentKey: 'receiverAddress',
  }),
  letterDate: getInput({ preTag: 'letter_date', componentKey: 'letterDate' }),
  letterBody: getEditableDiv({
    preTag: 'letter_body',
    componentKey: 'letterBody',
  }),
  subjectLine: getInput({
    preTag: 'subject_line',
    componentKey: 'subjectLine',
  }),
  openGreeting: getInput({
    preTag: 'open_greeting',
    componentKey: 'openGreeting',
  }),
  closeGreeting: getInput({
    preTag: 'close_greeting',
    componentKey: 'closeGreeting',
  }),
});
